import React from "react"
import Banners from "./Banners"
import { OFFER_BANNER_CONFIG } from "constants/bannerModuleConfig"

const OfferBanners = () => <Banners moduleConfig={OFFER_BANNER_CONFIG} />

export default OfferBanners
